import SimpleCrudList from "../../components/crud/SimpleCrudList";

interface Coupon {
  id: string;
  code: string;
  name: string;
  discountAmount: number;
  minFare: number;
  status: boolean;
}

export default function Coupons() {
  return (
    <SimpleCrudList<Coupon>
      title="Coupons"
      apiPath="/coupons"
      baseRoute="/coupons"
      searchKeys={["code", "name"]}
      columns={[
        { key: "code", label: "Code" },
        { key: "name", label: "Name" },
        {
          key: "discountAmount",
          label: "Discount",
          render: (r) => `£${Number(r.discountAmount).toFixed(2)}`,
        },
        {
          key: "minFare",
          label: "Min fare",
          render: (r) => `£${Number(r.minFare).toFixed(0)}`,
        },
        { key: "status", label: "Active", render: (r) => (r.status ? "Yes" : "No") },
      ]}
    />
  );
}
